// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1tkqt","icon":"styles_icon__3Mo6e","title":"styles_title__30G-4","link":"styles_link__MC_k7","text":"styles_text__297r8"};